export default __webpack_public_path__ + "static/media/9_1.4f41b7e9.png";